import FJProductToVideoScriptEdit from './FJProductToVideoScriptEdit';
import { useSelector, useDispatch } from 'react-redux';
import { useCallback } from 'react';
import {
    setSliceProductName,
    setSliceProductDescription,
    setSliceProductMediaList,
} from '../../../redux/slices/FJSliceTextToVideo';
import FJActionTextToVideo from '../../../redux/action/FJActionTextToVideo';
import FJActionModal from '../../../redux/action/FJActionModal';
const FJProductToVideoScriptEditContainer = () => {
    const dispatch = useDispatch();
    const productName = useSelector(state => state.textToVideo.productName);
    const productDescription = useSelector(state => state.textToVideo.productDescription);
    const productMediaList = useSelector(state => state.textToVideo.productMediaList);
    const setProductName = useCallback(
        name => {
            dispatch(setSliceProductName(name));
        },
        [dispatch],
    );
    const setProductDescription = useCallback(
        description => {
            dispatch(setSliceProductDescription(description));
        },
        [dispatch],
    );
    const deleteMedia = useCallback(
        index => {
            const newProductMediaList = productMediaList.filter((item, idx) => idx !== index);
            dispatch(setSliceProductMediaList(newProductMediaList));
        },
        [dispatch, productMediaList],
    );
    const addMedia = useCallback(
        files => {
            dispatch(FJActionTextToVideo.onUploadMediaAction(files));
        },
        [dispatch],
    );
    const onNext = useCallback(() => {
        dispatch(FJActionTextToVideo.onProductToScriptAction());
    }, [dispatch]);
    const previewMedia = useCallback(
        data => {
            dispatch(FJActionModal.showMediaPreviewAction(data));
        },
        [dispatch],
    );
    return (
        <FJProductToVideoScriptEdit
            productName={productName}
            productDescription={productDescription}
            productMediaList={productMediaList}
            setProductName={setProductName}
            setProductDescription={setProductDescription}
            deleteMedia={deleteMedia}
            addMedia={addMedia}
            onNext={onNext}
            previewMedia={previewMedia}
        />
    );
};

export default FJProductToVideoScriptEditContainer;
